module.exports = __webpack_public_path__ + "img/pauli-y-root-13.afc4febf.svg";